<template>
    <v-app-bar app color="#1976D2" dark>
      <v-app-bar-nav-icon @click="toggleNavigationBar"></v-app-bar-nav-icon>
      <v-toolbar-title ></v-toolbar-title>
      <div class="flex-grow-1"></div>
      <h3>Usuario: {{nameUser}}</h3>
  <!--     <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn> -->
    </v-app-bar>
</template>

<script>
export default {
  data () {
    return {
      nameUser: '',
      name: ''
    }
  },
  mounted () {
    this.showName(JSON.parse(localStorage.getItem('user')))
  },
  methods: {
    toggleNavigationBar () {
      const vm = this
      vm.$emit('toggleNavigationBar')
    },
    showName (user) {
      this.nameUser = user.usuario
    }
  }
}
</script>
